import React, { FunctionComponent } from 'react';
import styles from './DueDateBadge.less';
import { formatHumanDate } from '@trello/dates';
import DueDateHelpers from 'app/scripts/views/internal/due-date-helpers';
import moment from 'moment';
import cx from 'classnames';
import { ClockIcon } from '@trello/nachos/icons/clock';
import { TestId } from '@trello/test-ids';

interface DueDateBadgeProps {
  className?: string;
  complete?: boolean;
  due: Date | null;
  onClick?: React.MouseEventHandler;
  testId?: TestId;
}

export const DueDateBadge: FunctionComponent<DueDateBadgeProps> = function ({
  className: customClassName,
  complete,
  due,
  onClick,
  testId,
}: DueDateBadgeProps) {
  const dueClassName = due
    ? DueDateHelpers.classForDueDate(moment(due).toDate(), complete || false)
    : 'unset';

  const className = cx(styles.badge, styles[dueClassName], customClassName);

  const dueText = due && formatHumanDate(due);
  const contents = (
    <>
      <ClockIcon
        dangerous_className={styles.icon}
        color={
          ['is-due-future', 'unset'].includes(dueClassName) ? 'dark' : 'light'
        }
        size="small"
      ></ClockIcon>
      {dueText}
    </>
  );

  return onClick ? (
    <button className={className} onClick={onClick} data-test-id={testId}>
      {contents}
    </button>
  ) : dueText ? (
    <span className={className} data-test-id={testId}>
      {contents}
    </span>
  ) : null;
};
